var _rect, _rect2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiProgress3(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_364_25775)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_364_25775_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.028 -0.028 0 32 28)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1035.71,
    y: -1035.71,
    width: 2071.43,
    height: 2071.43
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(245, 244, 218, 1) 0deg,rgba(247, 254, 213, 1) 53.8081deg,rgba(204, 254, 255, 1) 133.872deg,rgba(253, 207, 254, 1) 244.386deg,rgba(245, 238, 222, 1) 318.274deg,rgba(245, 244, 218, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 56,
    height: 56,
    rx: 8,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.96862745285034180,\"g\":0.99607843160629272,\"b\":0.83529412746429443,\"a\":1.0},\"position\":0.14946706593036652},{\"color\":{\"r\":0.80000001192092896,\"g\":0.99607843160629272,\"b\":1.0,\"a\":1.0},\"position\":0.37186601758003235},{\"color\":{\"r\":0.99215686321258545,\"g\":0.81176471710205078,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.67884975671768188},{\"color\":{\"r\":0.96078431606292725,\"g\":0.93333333730697632,\"b\":0.87058824300765991,\"a\":1.0},\"position\":0.88409465551376343}],\"stopsVar\":[],\"transform\":{\"m00\":3.4290112931175884e-15,\"m01\":-56.0,\"m02\":60.0,\"m10\":56.0,\"m11\":3.4290112931175884e-15,\"m12\":-3.4290112931175884e-15},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#FF6666",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5113 27.4254C41.5113 26.9241 41.23 26.4641 40.782 26.2361C39.6353 25.6521 38.4073 25.1147 37.0313 24.5921C34.7566 23.7201 33.0993 22.0374 32.238 19.7321C31.722 18.3334 31.1913 17.0881 30.6167 15.9254C30.3913 15.4721 29.9273 15.1841 29.422 15.1841C28.9167 15.1841 28.45 15.4721 28.2273 15.9267C27.654 17.0854 27.1247 18.3307 26.6087 19.7267C25.7473 22.0361 24.0887 23.7187 21.818 24.5894C20.434 25.1161 19.2047 25.6534 18.062 26.2361C17.6153 26.4627 17.334 26.9227 17.334 27.4241C17.334 27.9254 17.6153 28.3854 18.0633 28.6134C19.2127 29.1974 20.4407 29.7361 21.814 30.2561C24.0887 31.1281 25.746 32.8107 26.6073 35.1174C27.126 36.5214 27.6553 37.7641 28.2273 38.9227C28.4526 39.3774 28.9153 39.6654 29.422 39.6654C29.9286 39.6654 30.3926 39.3774 30.6167 38.9227C31.1913 37.7641 31.7206 36.5187 32.2353 35.1214C33.098 32.8121 34.758 31.1294 37.026 30.2587C38.4046 29.7361 39.6327 29.1987 40.782 28.6147C41.23 28.3867 41.5113 27.9281 41.5113 27.4254Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7951 20.7226C39.1351 20.896 39.4698 21.0386 39.7991 21.164C40.0751 21.2706 40.2685 21.468 40.3725 21.744C40.4951 22.0813 40.6351 22.4173 40.8045 22.7613C41.0271 23.2173 41.4911 23.508 41.9991 23.508H42.0018C42.5085 23.508 42.9725 23.22 43.1965 22.7653C43.3658 22.4226 43.5045 22.0853 43.6285 21.7506C43.7351 21.468 43.9285 21.2706 44.1991 21.1666C44.5338 21.04 44.8671 20.8973 45.2071 20.724C45.6551 20.4973 45.9365 20.036 45.9365 19.5346C45.9365 19.0333 45.6538 18.5733 45.2058 18.3466C44.8671 18.176 44.5338 18.0333 44.2031 17.9066C43.9285 17.8013 43.7351 17.604 43.6298 17.324C43.5045 16.9866 43.3658 16.6493 43.1951 16.3053C42.9711 15.852 42.5071 15.564 42.0005 15.564H41.9978C41.4898 15.564 41.0271 15.8533 40.8031 16.3093C40.6351 16.652 40.4951 16.9893 40.3738 17.32C40.2671 17.6026 40.0738 17.8 39.8031 17.904C39.4671 18.032 39.1338 18.1733 38.7938 18.3466C38.3458 18.5733 38.0645 19.0333 38.0645 19.5346C38.0645 20.036 38.3458 20.496 38.7938 20.7226H38.7951Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9379 34.9135C45.5152 34.6988 45.0979 34.5202 44.6872 34.3655C44.2352 34.1922 43.9059 33.8562 43.7366 33.4002C43.5806 32.9788 43.4059 32.5575 43.1952 32.1308C42.9699 31.6762 42.5059 31.3882 42.0006 31.3882C41.4926 31.3882 41.0286 31.6775 40.8059 32.1335C40.5966 32.5602 40.4219 32.9802 40.2699 33.3935C40.0966 33.8562 39.7672 34.1922 39.3219 34.3628C38.9059 34.5202 38.4872 34.6989 38.0659 34.9149C37.6192 35.1429 37.3379 35.6015 37.3379 36.1028C37.3379 36.6042 37.6192 37.0629 38.0659 37.2909C38.4872 37.5055 38.9032 37.6829 39.3179 37.8415C39.7672 38.0135 40.0966 38.3482 40.2672 38.8055C40.4219 39.2255 40.5966 39.6469 40.8072 40.0722C41.0312 40.5269 41.4939 40.8148 42.0019 40.8162C42.5086 40.8162 42.9712 40.5295 43.1966 40.0749C43.4086 39.6482 43.5832 39.2269 43.7379 38.8095C43.9086 38.3482 44.2379 38.0135 44.6872 37.8415C45.1032 37.6829 45.5179 37.5068 45.9392 37.2922C46.3872 37.0642 46.6686 36.6042 46.6686 36.1028C46.6686 35.6015 46.3872 35.1415 45.9392 34.9135H45.9379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_364_25775",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_364_25775"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_364_25775",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_364_25775_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 56,
    height: 56,
    rx: 8,
    shapeRendering: "crispEdges"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiProgress3);
export default __webpack_public_path__ + "static/media/AI-progress-3.36168b11e3d679d0f06bf11daed2f61b.svg";
export { ForwardRef as ReactComponent };